import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { Section } from "@roqua/components/sections";

import { LoginForm } from "@/components/SelfRegistrations/LoginForm";
import { graphql } from "@/gql";
import { useClient } from "@/graphql/client";

const Query = graphql(/* GraphQL */ `
  query RegistrationLoginPage($slug: String!) {
    selfRegistrationPage(slug: $slug) {
      id
      title
      logoUrl
    }
  }
`);

export const Route = createFileRoute("/registration/$slug/login")({
  component: RouteComponent,
});

function RouteComponent() {
  const { slug } = Route.useParams();
  const client = useClient();
  const {
    data: { selfRegistrationPage },
  } = useSuspenseQuery({
    queryKey: ["SelfRegistrationLoginPage", slug],
    queryFn: () => client.request(Query, { slug }),
  });

  return (
    <main className="">
      <Section variant="header">
        {selfRegistrationPage.logoUrl && (
          <img src={selfRegistrationPage?.logoUrl} alt="" width="400" height="200" />
        )}
        <h2 className="mb-4 text-xl">{selfRegistrationPage.title}</h2>
      </Section>
      <Section variant="content">
        <LoginForm selfRegistrationPageId={selfRegistrationPage.id} />
      </Section>
    </main>
  );
}
